import React from 'react'
import { CarouselProvider, Slider, Slide, Image, Dot } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { Grid, Hidden, makeStyles } from '@material-ui/core'
import { isWebpSupported } from 'react-image-webp/dist/utils'
import noImage from '../../assets/img/noImage.png'

const useStyles = makeStyles((theme) => ({
  mainIgmWrapper: {
    height: '100%',
  },

  navigationWrapper: {
    height: '590px',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },

  navigationWrapperMobile: {
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },

  navigationScrollbarWidth: {
    '&::-webkit-scrollbar': {
      width: 4,
    },
  },

  navigationScrollbarWidthMobile: {
    scrollbarWidth: 'thin',
  },

  navigationScrollbar: {
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      borderRadius: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: '#CCC',
      borderRadius: '10px',
    },

    '&::-webkit-scrollbar-thumb:hover': {
      background: '#999',
    },

    '&::-webkit-scrollbar-thumb:active': {
      background: '#999',
    },

    '&::-webkit-scrollbar-corner': {
      background: '#f1f1f1',
    },
  },

  navigation: {
    width: 100,
    height: 100,
    border: 'none',
    borderRadius: 0,
    backgroundColor: '#FFF',
    marginBottom: theme.spacing(1),
  },
}))

const ProductCarousel = (props) => {
  const classes = useStyles(props)

  const checkWebpSupport = (webp, otherFormat) => {
    if (isWebpSupported() && webp) return webp
    else return otherFormat
  }

  return (
    <CarouselProvider
      visibleSlides={1}
      totalSlides={props?.images?.length}
      step={1}
      naturalSlideWidth={100}
      naturalSlideHeight={100}
      interval={7000}
      hasMasterSpinner
    >
      <Grid container spacing={1}>
        <Hidden smDown>
          <Grid
            item
            xs={2}
            className={[classes.navigationWrapper, classes.navigationScrollbarWidth, classes.navigationScrollbar]}
          >
            {props?.images?.map((image, index) => {
              return (
                <Dot
                  key={index}
                  style={{
                    /* backgroundImage: `url("${checkWebpSupport(
                      image?.full_webp_url,
                      image?.full_url
                    )}"), url("${noImage}")`, */
                    backgroundImage: `url("${image?.url}")`,
                    backgroundSize: 'cover',
                  }}
                  className={classes.navigation}
                  slide={index}
                />
              )
            })}
          </Grid>
        </Hidden>
        <Grid item sm={10} xs={12} className={classes.mainIgmWrapper}>
          <Slider>
            {props?.images?.map((image, index) => {
              return (
                <Slide key={index} index={index}>
                  <Image
                    hasMasterSpinner
                    /* src={isWebpSupported() && image?.full_webp_url ? image?.full_webp_url : image?.full_url} */
                    alt={image?.title}
                    title={image?.title}
                    src={image?.url}
                    renderError={() => <Image src={noImage} />}
                  />
                </Slide>
              )
            })}
          </Slider>
        </Grid>
        <Hidden smUp>
          <Grid
            item
            xs={12}
            className={[
              classes.navigationWrapperMobile,
              classes.navigationScrollbarWidthMobile,
              classes.navigationScrollbar,
            ]}
          >
            {props?.images?.map((image, index) => {
              return (
                <Dot
                  key={index}
                  style={{
                    /* backgroundImage: `url("${checkWebpSupport(
                      image?.full_webp_url,
                      image?.full_url
                    )}"), url("${noImage}")`, */
                    backgroundImage: `url("${image?.url}")`,
                    backgroundSize: 'cover',
                    marginRight: '5px',
                  }}
                  className={classes.navigation}
                  slide={index}
                />
              )
            })}
          </Grid>
        </Hidden>
      </Grid>
    </CarouselProvider>
  )
}

export default ProductCarousel
